"use client"

import { useState, useEffect } from "react"
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import MDBadge from "components/MDBadge"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import VisibilityOutlinedIcon from "@mui/icons-material/Visibility"
import DataTable from "examples/Tables/DataTable"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useTheme } from "@mui/material/styles"
import { Select } from "semantic-ui-react"
import moment from "moment"
import { ToastContainer, toast } from "react-toastify"
import InputBase from "@mui/material/InputBase"
import Paper from "@mui/material/Paper"
import SearchIcon from "@mui/icons-material/Search"
import AddIcon from "@mui/icons-material/Add"
import { Stack } from "@mui/material"
import colors from "assets/theme/base/colors"
import Tooltip from "@mui/material/Tooltip"
import DefineCriteriaModal from "./Components/DefineCriteriaModal"
import AssignDegreesModal from "./Components/AssignDegreesModal"
import { Tune } from "@mui/icons-material"
import "../campus/Campus.css"
import { useNavigate } from "react-router-dom"
import nodata from "assets/images/nodata.png"

const BASE_URL = process.env.REACT_APP_BASE_URL
const token = sessionStorage.getItem("token")
const label = { inputProps: { "aria-label": "Switch demo" } }
const { info } = colors
import { hasAdmissionPermission } from "hooks/permissions"
import AssessmentIcon from "@mui/icons-material/Assessment"
import CircularProgress from "@mui/material/CircularProgress"

function Campaign() {
  //Variable Declarations
  const [name, setName] = useState("")
  const [max_preferences, setMaxPreferences] = useState("")
  const [included_preferences, setIncludedPreferences] = useState("")
  const [extra_price_per_preference, setExtraPricePerPreference] = useState("")
  const [campus_id, setCampusId] = useState("")
  const [start_date, setStartDate] = useState("")
  const [end_date, setEndDate] = useState("")
  const [status, setStatus] = useState("")
  const [is_admission_open, setIsAdmissionOpen] = useState("") // New field
  const [want_fsc_mark_limit, setWantFscMarkLimit] = useState("0")
  const [max_dae_total_mark, setMaxDaeTotalMark] = useState("")
  const [max_other_than_dae_total_marks, setMaxOtherThanDaeTotalMarks] = useState("")
  const [entry_test, setEntryTest] = useState("")
  const [batch, setBatch] = useState("")
  const [prospectus_type, setProspectusType] = useState("")
  const [online_price, setOnlinePrice] = useState("")
  const [cash_price, setCashPrice] = useState("")
  const [price_per_test, setPricePerTest] = useState("")
  const [description, setDescription] = useState("")
  const [campaigns, setCampaigns] = useState([{}])
  const [entry_tests, setEntryTests] = useState([{}])
  const [batches, setBatches] = useState([{}])
  const [campuses, setCampuses] = useState([{}])
  const [showDeleteCampaignModal, setShowDeleteCampaignModal] = useState(false)
  const [showAddCampaignModal, setShowAddCampaignModal] = useState(false)
  const [showUpdateCampaignModal, setShowUpdateCampaignModal] = useState(false)
  const [showAssignDegreesModal, setShowAssignDegreesModal] = useState(false)
  const [showViewCampaignModal, setShowViewCampaignModal] = useState(false)
  const [degrees, setDegrees] = useState([{}])
  const [departments, setDepartments] = useState([])
  const [selectedDegrees, setSelectedDegrees] = useState([])
  const [selectedDepartments, setSelectedDepartments] = useState([])
  const [testRequired, setTestRequired] = useState(1)
  const [selectedCampaignId, setSelectedCampaignId] = useState(null)
  const [searchKeyword, setSearchKeyword] = useState("")
  const [loading, setLoading] = useState(false)
  const [formErrors, setFormErrors] = useState({
    name,
    campus_id,
    start_date,
    end_date,
    status,
    is_admission_open, // Add to form errors
    entry_test,
    batch,
    prospectus_type,
    online_price,
    cash_price,
    max_preferences,
    price_per_test,
    included_preferences,
    extra_price_per_preference,
    want_fsc_mark_limit: "",
    max_dae_total_mark: "",
    max_other_than_dae_total_marks: "",
  })
  const [maxWidth, setMaxWidth] = useState("md")
  const navigate = useNavigate()

  const callErrors = (
    NAME,
    CAMPUS,
    STARTDATE,
    ENDDATE,
    STATUS,
    ISADMISSIONOPEN, // Add parameter
    ENTRYTEST,
    BATCH,
    PROSPECTUSTYPE,
    ONLINEPRICE,
    CASHPRICE,
    PREFERNCE,
    PRICEPERTEST,
    INCLUDEDPREFERENCES,
    EXTRAPRICEPERPREFERENCE,
    WANTFSCMARKLIMIT,
    MAXDAETOTALMARK,
    MAXOTHERTHANDAETOTALMARKS,
  ) => {
    const errors = {}
    if (NAME === "") {
      errors.name = " * Campaign name is Required"
    }
    if (CAMPUS === "") {
      errors.campus_id = " * Please Select the Campus"
    }
    if (STARTDATE === "") {
      errors.start_date = " * Please Select the Start Date"
    }
    if (ENDDATE === "") {
      errors.end_date = " * Please Select the End Date"
    }
    if (STATUS === "") {
      errors.status = " * Please Select the Status"
    }
    if (ISADMISSIONOPEN === "") {
      errors.is_admission_open = " * Please Select Admission Status"
    }
    if (ENTRYTEST === "") {
      errors.entry_test = " * Please Select the Entry Test"
    }
    if (BATCH === "") {
      errors.batch = " * Please Select the Batch"
    }
    if (PROSPECTUSTYPE === "") {
      errors.prospectus_type = " * Please Select the Prospectus Type"
    }
    if (ONLINEPRICE === "") {
      errors.online_price = " * Please Enter the Online Price"
    }
    if (CASHPRICE === "") {
      errors.cash_price = " * Please Enter the Cash Price"
    }
    if (PREFERNCE === "") {
      errors.max_preferences = " * Please Enter the preference"
    }
    if (PRICEPERTEST === "") {
      errors.price_per_test = " * Please Enter the Price per Test"
    }
    if (INCLUDEDPREFERENCES === "") {
      errors.included_preferences = " * Please Enter the Included Preferences"
    }
    if (EXTRAPRICEPERPREFERENCE === "") {
      errors.extra_price_per_preference = " * Please Enter the Extra Price per Preference"
    }
    if (!description) {
      errors.description = " * Please enter a description"
    }
    if (WANTFSCMARKLIMIT === "" || WANTFSCMARKLIMIT === undefined || WANTFSCMARKLIMIT === null) {
      errors.want_fsc_mark_limit = " * Please select FSC mark limit option"
    }
    if (Number(WANTFSCMARKLIMIT) === 1) {
      if (!MAXDAETOTALMARK || Number(MAXDAETOTALMARK) <= 0) {
        errors.max_dae_total_mark = " * Please enter max DAE total marks"
      }
      if (!MAXOTHERTHANDAETOTALMARKS || Number(MAXOTHERTHANDAETOTALMARKS) <= 0) {
        errors.max_other_than_dae_total_marks = " * Please enter max other than DAE total marks"
      }
    }
    setFormErrors(errors)
  }

  const [anchorEl, setAnchorEl] = useState(null)
  const [opens, setOpens] = useState(false)
  const [currentAppId, setCurrentAppId] = useState(null)

  const handleClick = (event, appId) => {
    setAnchorEl(event.currentTarget)
    setOpens(true)
    setCurrentAppId(appId)
  }

  const handleClose = () => {
    setAnchorEl(null)
    setOpens(false)
    setCurrentAppId(null)
  }

  const viewCampaign = (id) => {
    const campaign = campaigns.find((d) => d.id === id)
    setSelectedCampaignId(campaign)
    setShowViewCampaignModal(true)
  }

  const copyCampaign = (id) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    fetch(BASE_URL + `/campaign/copy_campaign/${id}`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getCampaigns()
        toast.success("Campaign Copied Successfully")
      })
      .catch((error) => console.log(error))
  }

  const handleToggleDegree = (id) => {
    return (e) => {
      const { checked } = e.target
      const updatedDegrees = selectedDegrees.map((degree) => {
        if (degree.degree_id === id) {
          return {
            ...degree,
            test_required: checked ? 1 : 0,
          }
        }
        return degree
      })
      setSelectedDegrees(updatedDegrees)
    }
  }

  const handleSeatsChange = (e, id) => {
    const { value } = e.target
    const updatedDegrees = selectedDegrees.map((degree) => {
      if (degree.degree_id === id) {
        return {
          ...degree,
          seats: value,
        }
      }
      return degree
    })
    setSelectedDegrees(updatedDegrees)
  }

  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase()
    setSearchKeyword(searchTerm)
    if (searchTerm === "") {
      getCampaigns()
    } else {
      const filteredCampaigns = campaigns.filter((camp) => {
        const nameMatch = camp.name && camp.name.toLowerCase().includes(searchTerm)
        const campaignTypeNameMatch =
          camp.campaign_type_name && camp.campaign_type_name.toLowerCase().includes(searchTerm)
        const campusNameMatch = camp.campus_name && camp.campus_name.toLowerCase().includes(searchTerm)
        const entryTestNameMatch = camp.entry_test_name && camp.entry_test_name.toLowerCase().includes(searchTerm)
        const startDateMatch = camp.start_date && camp.start_date.toLowerCase().includes(searchTerm)
        const endDateMatch = camp.end_date && camp.end_date.toLowerCase().includes(searchTerm)
        const descriptionMatch = camp.description && camp.description.toLowerCase().includes(searchTerm)
        const bacthMatch = camp.batch && camp.batch.toLowerCase().includes(searchTerm)
        return (
          nameMatch ||
          campaignTypeNameMatch ||
          campusNameMatch ||
          startDateMatch ||
          endDateMatch ||
          descriptionMatch ||
          bacthMatch ||
          entryTestNameMatch
        )
      })
      setCampaigns(filteredCampaigns)
    }
  }

  //Dialog Settings
  const [open, setOpen] = useState(false)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))

  //Session Storage Rendering
  var user = JSON.parse(sessionStorage.getItem("user"))
  let organization_id
  if (user) {
    organization_id = user.organization_id
  } else {
    organization_id = null
  }

  //GET Api Calls
  const getCampaigns = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    await fetch(`${BASE_URL}/campaign/get_campaigns`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setCampaigns(data.campaigns)
      })
      .catch((error) => console.log(error))
  }

  const getBatches = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    await fetch(`${BASE_URL}/batch/get_batches`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setBatches(data.batches)
      })
      .catch((error) => console.log(error))
  }

  const getEntryTests = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    await fetch(`${BASE_URL}/entrytest/get_entry_tests`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setEntryTests(data.entry_tests)
      })
      .catch((error) => console.log(error))
  }

  const getCampuses = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    await fetch(`${BASE_URL}/campus/get_campuses`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setCampuses(data.campuses)
      })
      .catch((error) => console.log("error", error))
  }

  // Add Functions
  const showCampaignAddModal = () => {
    setShowAddCampaignModal(true)
  }

  const handleOkAddCampaignModal = () => {
    const fscMarksValid =
      Number(want_fsc_mark_limit) !== 1 ||
      (max_dae_total_mark && Number(max_dae_total_mark) > 0 &&
        max_other_than_dae_total_marks && Number(max_other_than_dae_total_marks) > 0)

    if (
      name &&
      start_date &&
      end_date &&
      status &&
      is_admission_open &&
      batch &&
      prospectus_type &&
      max_preferences &&
      price_per_test &&
      want_fsc_mark_limit !== "" &&
      fscMarksValid
    ) {
      addCampaign()
      setShowAddCampaignModal(false)
    } else {
      callErrors(
        name,
        "",
        start_date,
        end_date,
        status,
        is_admission_open,
        "",
        batch,
        prospectus_type,
        online_price,
        cash_price,
        max_preferences,
        price_per_test,
        included_preferences,
        extra_price_per_preference,
        want_fsc_mark_limit,
        max_dae_total_mark,
        max_other_than_dae_total_marks,
      )
    }
  }

  const handleFocus = (e) => {
    const { name } = e.target
    setFormErrors((prevFormErrors) => ({
      ...prevFormErrors,
      [name]: "",
    }))
  }

  const handleCancelAddCampaignModal = () => {
    setShowAddCampaignModal(false)
    setName("")
    setCampusId("")
    setStartDate("")
    setEndDate("")
    setStatus("")
    setIsAdmissionOpen("") // Reset field
    setWantFscMarkLimit("0")
    setMaxDaeTotalMark("")
    setMaxOtherThanDaeTotalMarks("")
    setEntryTest("")
    setBatch("")
    setProspectusType("")
    setOnlinePrice("")
    setCashPrice("")
    setMaxPreferences("")
    setPricePerTest("")
    setFormErrors({
      name: "",
      campus_id: "",
      start_date: "",
      end_date: "",
      status: "",
      is_admission_open: "", // Reset error
      entry_test: "",
      batch: "",
      prospectus_type: "",
      max_preferences: "",
      price_per_test: "",
      want_fsc_mark_limit: "",
      max_dae_total_mark: "",
      max_other_than_dae_total_marks: "",
    })
  }

  const addCampaign = async () => {
    const formattedStartDate = moment(start_date, "DD-MM-YYYY").format("YYYY-MM-DD")
    const formattedEndDate = moment(end_date, "DD-MM-YYYY").format("YYYY-MM-DD")
    const data = {
      name,
      start_date,
      end_date,
      status,
      is_admission_open, // Add to API payload
      batch_id: batch,
      prospectus_type,
      online_price,
      cash_price,
      max_preferences,
      included_preferences,
      extra_price_per_preference,
      price_per_test,
      description,
      want_fsc_mark_limit: Number(want_fsc_mark_limit),
      max_dae_total_mark: Number(want_fsc_mark_limit) === 1 ? Number(max_dae_total_mark) : 0,
      max_other_than_dae_total_marks:
        Number(want_fsc_mark_limit) === 1 ? Number(max_other_than_dae_total_marks) : 0,
    }
    console.log("Add Campaign", data)
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    }
    await fetch(`${BASE_URL}/campaign/add_campaign`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getCampaigns()
        toast("Campaign Added Successfully")
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setName("")
        setCampusId("")
        setStartDate("")
        setEndDate("")
        setStatus("")
        setIsAdmissionOpen("") // Reset field
        setWantFscMarkLimit("0")
        setMaxDaeTotalMark("")
        setMaxOtherThanDaeTotalMarks("")
        setEntryTest("")
        setBatch("")
        setProspectusType("")
        setOnlinePrice("")
        setCashPrice("")
        setMaxPreferences("")
        setPricePerTest("")
        setFormErrors({
          name: "",
          start_date: "",
          end_date: "",
          status: "",
          is_admission_open: "", // Reset error
          batch: "",
          prospectus_type: "",
          max_preferences: "",
          price_per_test: "",
          want_fsc_mark_limit: "",
          max_dae_total_mark: "",
          max_other_than_dae_total_marks: "",
        })
      })
  }

  // Delete Functions
  const showCampaignDeleteModal = () => {
    setShowDeleteCampaignModal(true)
  }

  const handleOkDeleteCampaignModal = () => {
    deleteCampaign()
    setShowDeleteCampaignModal(false)
  }

  const handleCancelDeleteCampaignModal = () => {
    setShowDeleteCampaignModal(false)
  }

  const deleteCampaign = async () => {
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    await fetch(`${BASE_URL}/campaign/delete_campaign/${currentAppId}`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        getCampaigns()
        toast.success("Campaign Deleted Successfully")
      })
      .catch((error) => console.log(error))
  }

  const [selectedCompaign, setSelectedCompaign] = useState(null)

  // Update Functions
  const showCampaignUpdateModal = (id) => {
    const campaignToUpdate = campaigns.find((campaign) => campaign.id === id)
    if (campaignToUpdate) {
      setSelectedCompaign(campaignToUpdate)
      setShowUpdateCampaignModal(true)
    }
  }

  const handleOkUpdateCampaignModal = () => {
    const fscMarksValid =
      Number(selectedCompaign?.want_fsc_mark_limit) !== 1 ||
      (selectedCompaign?.max_dae_total_mark && Number(selectedCompaign.max_dae_total_mark) > 0 &&
        selectedCompaign?.max_other_than_dae_total_marks &&
        Number(selectedCompaign.max_other_than_dae_total_marks) > 0)

    if (
      selectedCompaign.id &&
      selectedCompaign.name &&
      selectedCompaign.start_date &&
      selectedCompaign.end_date &&
      selectedCompaign.batch_id &&
      selectedCompaign.is_admission_open !== undefined &&
      selectedCompaign.want_fsc_mark_limit !== undefined &&
      selectedCompaign.want_fsc_mark_limit !== "" &&
      fscMarksValid
    ) {
      updateCampaign()
      setShowUpdateCampaignModal(false)
    } else {
      callErrors(
        selectedCompaign.name,
        "",
        selectedCompaign.start_date,
        selectedCompaign.end_date,
        selectedCompaign.status,
        selectedCompaign.is_admission_open,
        "",
        selectedCompaign.batch_id,
        selectedCompaign.prospectus_type,
        selectedCompaign.online_price,
        selectedCompaign.cash_price,
        selectedCompaign.max_preferences,
        selectedCompaign.price_per_test,
        selectedCompaign.included_preferences,
        selectedCompaign.extra_price_per_preference,
        selectedCompaign.want_fsc_mark_limit,
        selectedCompaign.max_dae_total_mark,
        selectedCompaign.max_other_than_dae_total_marks,
      )
    }
  }

  const handleCancelUpdateCampaignModal = () => {
    setShowUpdateCampaignModal(false)
    setName("")
    setCampusId("")
    setStartDate("")
    setEndDate("")
    setStatus("")
    setIsAdmissionOpen("") // Reset field
    setEntryTest("")
    setBatch("")
    setProspectusType("")
    setOnlinePrice("")
    setCashPrice("")
    setFormErrors({
      name: "",
      campus_id: "",
      start_date: "",
      end_date: "",
      status: "",
      is_admission_open: "", // Reset error
      entry_test: "",
      batch: "",
      prospectus_type: "",
      online_price: "",
      cash_price: "",
      price_per_test: "",
    })
  }

  const updateCampaign = async () => {
    if (selectedCompaign) {
      const data = {
        id: selectedCompaign.id,
        name: selectedCompaign.name,
        start_date: selectedCompaign.start_date,
        end_date: selectedCompaign.end_date,
        status: selectedCompaign.status,
        is_admission_open: selectedCompaign.is_admission_open, // Add to API payload
        batch_id: selectedCompaign.batch_id,
        prospectus_type: selectedCompaign.prospectus_type,
        online_price: selectedCompaign.online_price,
        cash_price: selectedCompaign.cash_price,
        max_preferences: selectedCompaign.max_preferences,
        included_preferences: selectedCompaign.included_preferences,
        extra_price_per_preference: selectedCompaign.extra_price_per_preference,
        price_per_test: selectedCompaign.price_per_test,
        description: selectedCompaign.description,
        want_fsc_mark_limit: Number(selectedCompaign.want_fsc_mark_limit),
        max_dae_total_mark:
          Number(selectedCompaign.want_fsc_mark_limit) === 1
            ? Number(selectedCompaign.max_dae_total_mark)
            : 0,
        max_other_than_dae_total_marks:
          Number(selectedCompaign.want_fsc_mark_limit) === 1
            ? Number(selectedCompaign.max_other_than_dae_total_marks)
            : 0,
      }
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      }
      await fetch(`${BASE_URL}/campaign/update_campaign`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          getCampaigns()
          toast.success("Campaign Updated Successfully")
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setName("")
          setCampusId("")
          setStartDate("")
          setEndDate("")
          setStatus("")
          setIsAdmissionOpen("") // Reset field
          setEntryTest("")
          setBatch("")
          setProspectusType("")
          setOnlinePrice("")
          setCashPrice("")
          setMaxPreferences("")
          setPricePerTest("")
          setFormErrors({
            name: "",
            campus_id: "",
            start_date: "",
            end_date: "",
            status: "",
            is_admission_open: "", // Reset error
            entry_test: "",
            batch: "",
            prospectus_type: "",
            online_price: "",
            cash_price: "",
            price_per_test: "",
          })
          setShowUpdateCampaignModal(false)
        })
    }
  }

  const formatDate = (dateString) => {
    if (!dateString) return "" // Return an empty string if no date is provided
    const utcDate = moment.utc(dateString)
    return utcDate.format("YYYY-MM-DD")
    const localDate = utcDate.local()
    const day = localDate.date()
    const month = localDate.month() + 1
    const year = localDate.year()
    return `${day}-${month}-${year}`
  }

  const formatDateTime = (dateString) => {
    const utcDate = moment.utc(dateString)
    const localDate = utcDate.local()
    const day = localDate.date()
    const month = localDate.month() + 1
    const year = localDate.year()
    const hours = localDate.hours()
    const minutes = localDate.minutes()
    return `${day}-${month}-${year} ${hours}:${minutes}`
  }

  //assign degree fuctions
  const handleshowAssignDegreesModal = (id) => {
    setSelectedCampaignId(id)
    getSelectedDegrees(id)
    setShowAssignDegreesModal(true)
  }

  const handleOkAssignDegreesModal = () => {
    assignDegrees()
    setShowAssignDegreesModal(false)
  }

  const handleCancelAssignDegreesModal = () => {
    setShowAssignDegreesModal(false)
    setSelectedDegrees([])
    setSelectedCampaignId(null)
  }

  const getDegrees = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    await fetch(`${BASE_URL}/department/get_departments_with_programs`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setDepartments(data.departments)
        // console.log("Degrees", data.degrees);
      })
      .catch((error) => console.log(error))
  }

  const handleDownload = async (campaign_id) => {
    window.open(`${BASE_URL}/campaign/seat_breakup_report/${campaign_id}`, "_blank")
  }

  const assignDegrees = async () => {
    if (selectedCampaignId) {
      const data = {
        campaign_id: selectedCampaignId,
        degrees: selectedDegrees.map((degree) => ({
          degree_id: degree.degree_id,
          test_required: degree.test_required,
          seats: degree.seats,
        })),
      }
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      }
      await fetch(`${BASE_URL}/campaign/assgin_degrees_to_campaign`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          getCampaigns()
          toast.success("Programs Assigned Successfully")
        })
        .catch((error) => console.log(error))
        .finally(() => {
          setSelectedDegrees([])
          setSelectedCampaignId(null)
        })
    }
  }

  const getSelectedDegrees = async (id) => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    await fetch(`${BASE_URL}/campaign/get_degrees_in_campaign/${id}`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        const selectedDegrees = data.degrees.map((degree) => ({
          degree_id: degree.degree_id,
          test_required: degree.test_required,
          seats: degree.seats,
        }))
        setSelectedDegrees(selectedDegrees)
      })
      .catch((error) => console.log(error))
  }

  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Session", accessor: "batch", align: "center" },
    { Header: "Start Date", accessor: "start_date", align: "center" },
    { Header: "End Date", accessor: "end_date", align: "center" },
    { Header: "Status", accessor: "badge", align: "center" },
    { Header: "Admission Status", accessor: "admission_badge", align: "center" }, // Add column
    { Header: "Assign Programs", accessor: "assign_degrees", align: "center" },
    { Header: "Define Criteria", accessor: "define_criteria", align: "center" },
    { Header: "Actions", accessor: "actions", align: "center" },
  ]

  const rows =
    campaigns.length > 0
      ? campaigns.map((campaign, index) => {
          const startDate = new Date(campaign.start_date)
          const endDate = new Date(campaign.end_date)
          const startDateFormatted = `${startDate.getDate()}/${startDate.getMonth() + 1}/${startDate.getFullYear()}`
          const endDateFormatted = `${endDate.getDate()}/${endDate.getMonth() + 1}/${endDate.getFullYear()}`
          return {
            serial: index + 1,
            name: campaign.name,
            batch: campaign.batch_name,
            start_date: startDateFormatted,
            end_date: endDateFormatted,
            badge:
              campaign.status === 1 ? (
                <MDBox ml={-1}>
                  <MDBadge badgeContent="Active" color="success" variant="gradient" size="sm" />
                </MDBox>
              ) : (
                <MDBox ml={-1}>
                  <MDBadge badgeContent="Inactive" color="error" variant="gradient" size="sm" />
                </MDBox>
              ),
            // Add admission status badge
            admission_badge:
              campaign.is_admission_open === 1 ? (
                <MDBox ml={-1}>
                  <MDBadge badgeContent="Open" color="info" variant="gradient" size="sm" />
                </MDBox>
              ) : (
                <MDBox ml={-1}>
                  <MDBadge badgeContent="Closed" color="warning" variant="gradient" size="sm" />
                </MDBox>
              ),
            actions: (
              <>
                {hasAdmissionPermission("Campaign", "UPDATE") && (
                  <Tooltip title="Edit" arrow>
                    <IconButton aria-label="edit" onClick={() => showCampaignUpdateModal(campaign.id)}>
                      <EditIcon className="icon-button-edit" />
                    </IconButton>
                  </Tooltip>
                )}
                {hasAdmissionPermission("Campaign", "READ") && (
                  <Tooltip title="View" arrow>
                    <IconButton onClick={() => viewCampaign(campaign.id)}>
                      <VisibilityOutlinedIcon className="icon-button-view" />
                    </IconButton>
                  </Tooltip>
                )}
                {hasAdmissionPermission("Campaign", "DELETE") && (
                  <Tooltip title="Delete" arrow>
                    <IconButton
                      aria-label="delete"
                      onClick={() => {
                        setCurrentAppId(campaign.id)
                        showCampaignDeleteModal()
                      }}
                    >
                      <DeleteIcon className="icon-button-delete" />
                    </IconButton>
                  </Tooltip>
                )}
                {hasAdmissionPermission("Campaign", "MANAGE") && (
                  <Tooltip title="Copy Campaign" arrow>
                    <IconButton
                      aria-label="copy"
                      onClick={() => {
                        copyCampaign(campaign.id)
                      }}
                    >
                      <ContentCopyIcon className="icon-button-view" />
                    </IconButton>
                  </Tooltip>
                )}
                {hasAdmissionPermission("Campaign", "MANAGE") && (
                  <Tooltip title="Seat Breakup Report" arrow>
                    <span>
                      <IconButton
                        aria-label="download"
                        onClick={() => {
                          handleDownload(campaign.id)
                        }}
                        disabled={loading}
                      >
                        {loading ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          <AssessmentIcon className="icon-button-view" />
                        )}
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </>
            ),
            assign_degrees: (
              <>
                {hasAdmissionPermission("Campaign", "MANAGE") && (
                  <Tooltip title="Assign Programs" arrow>
                    <IconButton aria-label="assign" onClick={() => navigate(`/assign-programs/${campaign.id}`)}>
                      <Tune className="icon-button-assign" />
                    </IconButton>
                  </Tooltip>
                )}
              </>
            ),
            define_criteria: (
              <>{hasAdmissionPermission("Campaign", "MANAGE") && <DefineCriteriaModal campaign_id={campaign.id} />}</>
            ),
          }
        })
      : [
          {
            serial: null,
            name: null,
            batch: null,
            prospectus_type: null,
            online_price: null,
            cash_price: null,
            status: null,
            admission_badge: null, // Add null value
            start_date: null,
            end_date: null,
            badge: null,
            assign_degrees: null,
            actions: null,
          },
        ]

  // Initial Renderings
  useEffect(() => {
    getCampaigns()
    getCampuses()
    getEntryTests()
    getDegrees()
    getBatches()
  }, [])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox
        // pl={2}
        pb={3}
      >
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card className="mt-5 card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                variant="gradient"
                // bgColor="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1} sx={{ width: "100%" }}>
                  <Stack sx={{ flexGrow: 1 }}>
                    <Paper component="form" className="search-paper">
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Search"
                        inputProps={{ "aria-label": "search voucher" }}
                        value={searchKeyword}
                        onChange={handleSearchKeywordChange}
                      />
                      <SearchIcon className="search-icon" />
                    </Paper>
                  </Stack>
                  {hasAdmissionPermission("Campaign", "CREATE") && (
                  <Button
                    variant="filled"
                    endIcon={<AddIcon className="add-icon" />}
                    onClick={showCampaignAddModal}
                    className="add-button"
                  >
                    Add
                  </Button>
                  )}
                </Stack>
              </MDBox>
              <MDBox pt={3}>
                {campaigns && campaigns.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={nodata || "/placeholder.svg"}
                      style={{
                        display: "block",
                        margin: "auto",
                        width: "20%",
                        height: "20%",
                      }}
                    />
                  </div>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Add Campaign */}
      <Dialog
        fullScreen={fullScreen}
        open={showAddCampaignModal}
        onClose={handleCancelAddCampaignModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        // fullWidth
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-title">
          {"Create Campaign"}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div className="row">
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Campaign Name</label>
                <input
                  name="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Demo Name"
                />
              </div>
              <div className="error-message1">{formErrors.name}</div>
            </div>
            <div className="col-md-6">
              <div className="mt-3">
                <label>Session</label>
                <Select
                  placeholder="Select Session"
                  fluid
                  selection
                  options={batches.map((batch) => ({
                    key: batch.id,
                    text: batch.name,
                    value: batch.id,
                  }))}
                  optionValue="value"
                  onChange={(e, { value }) => setBatch(value)}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message">{formErrors.batch}</div>
            </div>
            <div className="col-md-6">
              <div className="mt-3">
                <label>Prospectus Type</label>
                <Select
                  placeholder="Select Prospectus Type"
                  fluid
                  selection
                  value={prospectus_type}
                  onChange={(e, { value }) => setProspectusType(value)}
                  options={[
                    { key: 1, text: "Free", value: "Free" },
                    { key: 2, text: "Paid", value: "Paid" },
                  ]}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message">{formErrors.prospectus_type}</div>
            </div>
            {/* Conditionally render price fields based on the prospectus type */}
            {prospectus_type === "Paid" && (
              <>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Online Price</label>
                    <input
                      name="online_price"
                      type="number"
                      value={online_price}
                      onChange={(e) => setOnlinePrice(e.target.value)}
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Online Price"
                    />
                  </div>
                  <div className="error-message1">{formErrors.online_price}</div>
                </div>
                <div className="col-md-6">
                  <div className="mt-3">
                    <label>Cash Price</label>
                    <input
                      name="cash_price"
                      type="number"
                      value={cash_price}
                      onChange={(e) => setCashPrice(e.target.value)}
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Cash Price"
                    />
                  </div>
                  <div className="error-message">{formErrors.cash_price}</div>
                </div>
              </>
            )}
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label className="d-block">Start Date</label>
                <input
                  type="date"
                  value={formatDate(start_date)}
                  onChange={(e) => {
                    const dateValue = e.target.value // Get the value directly from the event target
                    setStartDate(dateValue)
                  }}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
                <div className="error-message">{formErrors.start_date}</div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mt-3">
                <label className="d-block">End Date</label>
                <input
                  type="date"
                  value={formatDate(end_date)}
                  onChange={(e) => {
                    const dateValue = e.target.value
                    setEndDate(dateValue)
                  }}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                />
                <div className="error-message">{formErrors.end_date}</div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Status</label>
                <Select
                  placeholder="Select Status"
                  fluid
                  selection
                  value={status}
                  onChange={(e, { value }) => setStatus(value)}
                  onFocus={handleFocus}
                  options={[
                    { key: 1, text: "Active", value: "1" },
                    { key: 0, text: "Inactive", value: "0" },
                  ]}
                  optionLabel="status"
                  optionValue="id"
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message1">{formErrors.status}</div>
            </div>
            {/* Add Admission Status field */}
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Admission Status</label>
                <Select
                  placeholder="Select Admission Status"
                  fluid
                  selection
                  value={is_admission_open}
                  onChange={(e, { value }) => setIsAdmissionOpen(value)}
                  onFocus={handleFocus}
                  options={[
                    { key: 1, text: "Open", value: "1" },
                    { key: 0, text: "Closed", value: "0" },
                  ]}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message1">{formErrors.is_admission_open}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>FSC Mark Limit</label>
                <Select
                  placeholder="Apply FSC mark limit?"
                  fluid
                  selection
                  value={String(want_fsc_mark_limit)}
                  onChange={(e, { value }) => {
                    setWantFscMarkLimit(value)
                    if (Number(value) !== 1) {
                      setMaxDaeTotalMark("")
                      setMaxOtherThanDaeTotalMarks("")
                    }
                  }}
                  onFocus={handleFocus}
                  options={[
                    { key: 1, text: "Yes", value: "1" },
                    { key: 0, text: "No", value: "0" },
                  ]}
                  className="form-control form-control-lg"
                />
              </div>
              <div className="error-message1">{formErrors.want_fsc_mark_limit}</div>
            </div>
            {Number(want_fsc_mark_limit) === 1 && (
              <>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Max DAE Total Marks</label>
                    <input
                      name="max_dae_total_mark"
                      type="number"
                      min="1"
                      value={max_dae_total_mark}
                      onChange={(e) => setMaxDaeTotalMark(e.target.value)}
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter max DAE total marks"
                    />
                  </div>
                  <div className="error-message1">{formErrors.max_dae_total_mark}</div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Max Other Than DAE Total Marks</label>
                    <input
                      name="max_other_than_dae_total_marks"
                      type="number"
                      min="1"
                      value={max_other_than_dae_total_marks}
                      onChange={(e) => setMaxOtherThanDaeTotalMarks(e.target.value)}
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter max other than DAE total marks"
                    />
                  </div>
                  <div className="error-message1">{formErrors.max_other_than_dae_total_marks}</div>
                </div>
              </>
            )}
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Max Preference</label>
                <input
                  name="max_preferences"
                  type="number"
                  value={max_preferences}
                  onChange={(e) => setMaxPreferences(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Max Preference"
                />
              </div>
              <div className="error-message1">{formErrors.max_preferences}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Included Preferences</label>
                <input
                  name="included_preferences"
                  type="number"
                  value={included_preferences}
                  onChange={(e) => setIncludedPreferences(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Included Preferences"
                />
              </div>
              <div className="error-message1">{formErrors.included_preferences}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Extra Price per Preference</label>
                <input
                  name="extra_price_per_preference"
                  type="number"
                  value={extra_price_per_preference}
                  onChange={(e) => setExtraPricePerPreference(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Extra Price per Preference"
                />
              </div>
              <div className="error-message1">{formErrors.extra_price_per_preference}</div>
            </div>
            <div className="col-md-6">
              <div className="form-outline mt-3">
                <label>Price Per Test</label>
                <input
                  name="price_per_test"
                  type="number"
                  value={price_per_test}
                  onChange={(e) => setPricePerTest(e.target.value)}
                  onFocus={handleFocus}
                  className="form-control form-control-lg"
                  placeholder="Enter Price Per Test"
                />
              </div>
              <div className="error-message1">{formErrors.price_per_test}</div>
            </div>
            <div className="col-md-12">
                <label>Description</label>
                <ReactQuill
                  value={description}
                  onChange={setDescription}
                  theme="snow"
                  // className="form-control form-control-lg"
                  style={{ background: 'white', minHeight: '200px' }}
                />
              </div>
              <div className="error-message1">{formErrors.description}</div>
          </div>
        </DialogContent>
        <DialogActions style={{ marginRight: "20px" }}>
          <Button className="dialog-actions-button negative" onClick={handleCancelAddCampaignModal}>
            Cancel
          </Button>
          <Button className="dialog-actions-button positive" onClick={handleOkAddCampaignModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog
        fullScreen={fullScreen}
        open={showDeleteCampaignModal}
        onClose={handleCancelDeleteCampaignModal}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          sx: {
            width: "450px",
            borderRadius: "20px",
            opacity: 1,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-delete">
          {"Delete Campaign"}
        </DialogTitle>
        <DialogContent className="content-delete">
          <DialogContentText>Are you sure to delete this Campaign?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="dialog-actions-button negative" onClick={handleCancelDeleteCampaignModal}>
            Cancel
          </Button>
          <Button className="dialog-actions-button positive" onClick={handleOkDeleteCampaignModal}>
            Done
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Dialog */}
      <Dialog
        fullScreen={fullScreen}
        open={showUpdateCampaignModal}
        onClose={handleCancelUpdateCampaignModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg" // Sets the width to large
        // fullWidth
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-title">
          {"Update Campaign"}
        </DialogTitle>
        <DialogContent className="dialog-content">
          {selectedCompaign && (
            <>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Campaign Name</label>
                    <input
                      name="name"
                      type="text"
                      value={selectedCompaign.name}
                      onChange={(e) =>
                        setSelectedCompaign({
                          ...selectedCompaign,
                          name: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Campaign Name"
                    />
                  </div>
                  <div className="error-message1">{formErrors.name}</div>
                </div>
                <div className="col-md-6">
                  <div className="mt-3">
                    <label>Session</label>
                    <Select
                      placeholder="Select Session"
                      fluid
                      selection
                      value={selectedCompaign.batch_id}
                      onChange={(e, { value }) =>
                        setSelectedCompaign({
                          ...selectedCompaign,
                          batch_id: value,
                        })
                      }
                      options={batches.map((batch) => ({
                        key: batch.id,
                        text: batch.name,
                        value: batch.id,
                      }))}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message">{formErrors.batch}</div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label>Prospectus Type</label>
                    <Select
                      placeholder="Select Prospectus Type"
                      fluid
                      selection
                      value={selectedCompaign.prospectus_type}
                      onChange={(e, { value }) =>
                        setSelectedCompaign({
                          ...selectedCompaign,
                          prospectus_type: value,
                        })
                      }
                      options={[
                        { key: "free", text: "Free", value: "Free" },
                        { key: "paid", text: "Paid", value: "Paid" },
                      ]}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message1">{formErrors.prospectus_type}</div>
                </div>
                {/* Conditionally render price fields based on prospectus type */}
                {selectedCompaign.prospectus_type === "Paid" && (
                  <>
                    <div className="col-md-6">
                      <div className="mt-3">
                        <label>Online Price</label>
                        <input
                          name="online_price"
                          type="number"
                          value={selectedCompaign.online_price}
                          onChange={(e) =>
                            setSelectedCompaign({
                              ...selectedCompaign,
                              online_price: e.target.value,
                            })
                          }
                          onFocus={handleFocus}
                          className="form-control form-control-lg"
                          placeholder="Enter Online Price"
                        />
                      </div>
                      <div className="error-message">{formErrors.online_price}</div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-outline mt-3">
                        <label>Cash Price</label>
                        <input
                          name="cash_price"
                          type="number"
                          value={selectedCompaign.cash_price}
                          onChange={(e) =>
                            setSelectedCompaign({
                              ...selectedCompaign,
                              cash_price: e.target.value,
                            })
                          }
                          onFocus={handleFocus}
                          className="form-control form-control-lg"
                          placeholder="Enter Cash Price"
                        />
                      </div>
                      <div className="error-message1">{formErrors.cash_price}</div>
                    </div>
                  </>
                )}
                <div className="col-md-6">
                  <div className="mt-3">
                    <label className="d-block">Start Date</label>
                    <input
                      name="start_date"
                      type="date"
                      value={formatDate(selectedCompaign?.start_date)}
                      onChange={(e) => {
                        const dateValue = e.target.value // Get the value directly from the event target
                        setSelectedCompaign({
                          ...selectedCompaign,
                          start_date: dateValue, // Set the value directly from the input
                        })
                      }}
                      onFocus={handleFocus}
                      //   onChange={(e, { name, value }) => setStartDate(value)}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message1">{formErrors.start_date}</div>
                </div>
                <div className="col-md-6">
                  <div className="form-outline mt-3">
                    <label className="d-block">End Date</label>
                    <input
                      type="date"
                      name="end_date"
                      value={formatDate(selectedCompaign?.end_date)}
                      onChange={(e) => {
                        const dateValue = e.target.value
                        setSelectedCompaign({
                          ...selectedCompaign,
                          end_date: dateValue,
                        })
                      }}
                      onFocus={handleFocus}
                      //   onChange={(e, { name, value }) => setEndDate(value)}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message1">{formErrors.end_date}</div>
                </div>
                <div className="col-md-6">
                  <div className="mt-3">
                    <label>Status</label>
                    <Select
                      placeholder="Select Status"
                      fluid
                      selection
                      value={selectedCompaign.status}
                      onChange={(e, { value }) =>
                        setSelectedCompaign({
                          ...selectedCompaign,
                          status: value,
                        })
                      }
                      onFocus={handleFocus}
                      options={[
                        { key: 1, text: "Active", value: 1 },
                        { key: 0, text: "Inactive", value: 0 },
                      ]}
                      optionValue="value"
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message">{formErrors.status}</div>
                </div>
                {/* Add Admission Status field to update form */}
                <div className="col-md-6">
                  <div className="mt-3">
                    <label>Admission Status</label>
                    <Select
                      placeholder="Select Admission Status"
                      fluid
                      selection
                      value={selectedCompaign.is_admission_open}
                      onChange={(e, { value }) =>
                        setSelectedCompaign({
                          ...selectedCompaign,
                          is_admission_open: value,
                        })
                      }
                      onFocus={handleFocus}
                      options={[
                        { key: 1, text: "Open", value: 1 },
                        { key: 0, text: "Closed", value: 0 },
                      ]}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message">{formErrors.is_admission_open}</div>
                </div>
                <div className="col-md-6">
                  <div className="mt-3">
                    <label>FSC Mark Limit</label>
                    <Select
                      placeholder="Apply FSC mark limit?"
                      fluid
                      selection
                      value={String(selectedCompaign.want_fsc_mark_limit ?? 0)}
                      onChange={(e, { value }) =>
                        setSelectedCompaign({
                          ...selectedCompaign,
                          want_fsc_mark_limit: Number(value),
                          max_dae_total_mark: Number(value) === 1 ? selectedCompaign.max_dae_total_mark : 0,
                          max_other_than_dae_total_marks:
                            Number(value) === 1 ? selectedCompaign.max_other_than_dae_total_marks : 0,
                        })
                      }
                      onFocus={handleFocus}
                      options={[
                        { key: 1, text: "Yes", value: 1 },
                        { key: 0, text: "No", value: 0 },
                      ]}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <div className="error-message">{formErrors.want_fsc_mark_limit}</div>
                </div>
                {Number(selectedCompaign.want_fsc_mark_limit) === 1 && (
                  <>
                    <div className="col-md-6">
                      <div className="mt-3">
                        <label>Max DAE Total Marks</label>
                        <input
                          name="max_dae_total_mark"
                          type="number"
                          min="1"
                          value={selectedCompaign.max_dae_total_mark || ""}
                          onChange={(e) =>
                            setSelectedCompaign({
                              ...selectedCompaign,
                              max_dae_total_mark: e.target.value,
                            })
                          }
                          onFocus={handleFocus}
                          className="form-control form-control-lg"
                          placeholder="Enter max DAE total marks"
                        />
                      </div>
                      <div className="error-message">{formErrors.max_dae_total_mark}</div>
                    </div>
                    <div className="col-md-6">
                      <div className="mt-3">
                        <label>Max Other Than DAE Total Marks</label>
                        <input
                          name="max_other_than_dae_total_marks"
                          type="number"
                          min="1"
                          value={selectedCompaign.max_other_than_dae_total_marks || ""}
                          onChange={(e) =>
                            setSelectedCompaign({
                              ...selectedCompaign,
                              max_other_than_dae_total_marks: e.target.value,
                            })
                          }
                          onFocus={handleFocus}
                          className="form-control form-control-lg"
                          placeholder="Enter max other than DAE total marks"
                        />
                      </div>
                      <div className="error-message">{formErrors.max_other_than_dae_total_marks}</div>
                    </div>
                  </>
                )}
                <div className="col-md-6">
                  <div className="mt-3">
                    <label>Max Preference</label>
                    <input
                      name="max_preferences"
                      type="number"
                      value={selectedCompaign.max_preferences}
                      onChange={(e) =>
                        setSelectedCompaign({
                          ...selectedCompaign,
                          max_preferences: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Max Preference"
                    />
                  </div>
                  <div className="error-message">{formErrors.max_preferences}</div>
                </div>
                <div className="col-md-6">
                  <div className="mt-3">
                    <label>Included Preferences</label>
                    <input
                      name="included_preferences"
                      type="number"
                      value={selectedCompaign.included_preferences}
                      onChange={(e) =>
                        setSelectedCompaign({
                          ...selectedCompaign,
                          included_preferences: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Included Preferences"
                    />
                  </div>
                  <div className="error-message">{formErrors.included_preferences}</div>
                </div>
                <div className="col-md-6">
                  <div className="mt-3">
                    <label>Extra Price per Preference</label>
                    <input
                      name="extra_price_per_preference"
                      type="number"
                      value={selectedCompaign.extra_price_per_preference}
                      onChange={(e) =>
                        setSelectedCompaign({
                          ...selectedCompaign,
                          extra_price_per_preference: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Extra Price per Preference"
                    />
                  </div>
                  <div className="error-message">{formErrors.extra_price_per_preference}</div>
                </div>
                <div className="col-md-6">
                  <div className="mt-3">
                    <label>Price Per Test</label>
                    <input
                      name="price_per_test"
                      type="number"
                      value={selectedCompaign.price_per_test}
                      onChange={(e) =>
                        setSelectedCompaign({
                          ...selectedCompaign,
                          price_per_test: e.target.value,
                        })
                      }
                      onFocus={handleFocus}
                      className="form-control form-control-lg"
                      placeholder="Enter Price Per Test"
                    />
                  </div>
                  <div className="error-message">{formErrors.price_per_test}</div>
                </div>
                <div className="col-md-12">
                    <label>Description</label>
                    <ReactQuill
                      value={selectedCompaign.description || ''}
                      onChange={(value) => setSelectedCompaign({ ...selectedCompaign, description: value })}
                      theme="snow"
                      // className="form-control form-control-lg"
                      style={{ background: 'white', minHeight: '200px' }}
                    />
                  </div>
                  <div className="error-message1">{formErrors.description}</div>
                </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button className="dialog-actions-button negative" onClick={handleCancelUpdateCampaignModal}>
            Cancel
          </Button>
          <Button className="dialog-actions-button positive" onClick={handleOkUpdateCampaignModal}>
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Batch Dialog */}
      <Dialog
        open={showViewCampaignModal}
        onClose={() => setShowViewCampaignModal(false)}
        PaperProps={{
          className: "dialog-paper",
        }}
      >
        <DialogTitle id="responsive-dialog-title" className="dialog-delete">
          View Campaign
        </DialogTitle>
        <DialogContent className="dialog-content">
          {selectedCampaignId && (
            <>
              <div className="flex-container">
                <strong className="label1">Name</strong>
                <span className="value1">{selectedCampaignId.name}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Batch Name</strong>
                <span className="value1">{selectedCampaignId.batch_name}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Campus</strong>
                <span className="value1">{selectedCampaignId.campus_name}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Entry Test</strong>
                <span className="value1">{selectedCampaignId.entry_test_name}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Prospectus Type</strong>
                <span className="value1">{selectedCampaignId.prospectus_type}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Online Price</strong>
                <span className="value1">{selectedCampaignId.online_price}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Cash Price</strong>
                <span className="value1">{selectedCampaignId.cash_price}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Price Per Test</strong>
                <span className="value1">{selectedCampaignId.price_per_test}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Max Preferences</strong>
                <span className="value1">{selectedCampaignId.max_preferences}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Included Preferences</strong>
                <span className="value1">{selectedCampaignId.included_preferences}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Extra Price per Preference</strong>
                <span className="value1">{selectedCampaignId.extra_price_per_preference}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">Start Date</strong>
                <span className="value1">{new Date(selectedCampaignId.start_date).toLocaleDateString()}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">End Date</strong>
                <span className="value1">{new Date(selectedCampaignId.end_date).toLocaleDateString()}</span>{" "}
              </div>
              <div className="flex-container">
                <strong className="label1">Status</strong>
                <span className="value1">{selectedCampaignId.status === 1 ? "Active" : "Inactive"}</span>
              </div>
              {/* Add Admission Status to view modal */}
              <div className="flex-container">
                <strong className="label1">Admission Status</strong>
                <span className="value1">{selectedCampaignId.is_admission_open === 1 ? "Open" : "Closed"}</span>
              </div>
              <div className="flex-container">
                <strong className="label1">FSC Mark Limit</strong>
                <span className="value1">{selectedCampaignId.want_fsc_mark_limit === 1 ? "Yes" : "No"}</span>
              </div>
              {selectedCampaignId.want_fsc_mark_limit === 1 && (
                <>
                  <div className="flex-container">
                    <strong className="label1">Max DAE Total Marks</strong>
                    <span className="value1">{selectedCampaignId.max_dae_total_mark}</span>
                  </div>
                  <div className="flex-container">
                    <strong className="label1">Max Other Than DAE Total Marks</strong>
                    <span className="value1">{selectedCampaignId.max_other_than_dae_total_marks}</span>
                  </div>
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button className="dialog-actions-button negative" onClick={() => setShowViewCampaignModal(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <AssignDegreesModal
        showAssignDegreesModal={showAssignDegreesModal}
        departments={departments}
        handleCancelAssignDegreesModal={handleCancelAssignDegreesModal}
        assignDegrees={assignDegrees}
        selectedDegrees={selectedDegrees}
        setSelectedDegrees={setSelectedDegrees}
        getDegrees={getDegrees}
        degrees={degrees}
        setDegrees={setDegrees}
      />
    </DashboardLayout>
  )
}

export default Campaign
